export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      role: 'Homeowner',
      avatar: 'SM',
      color: 'bg-teal-500',
      rating: 5,
      text: 'Working with Urban Spaces transformed our home beyond our wildest dreams. Their attention to detail and ability to understand our vision was remarkable. Every corner of our space now tells a story.'
    },
    {
      name: 'David Chen',
      role: 'Restaurant Owner',
      avatar: 'DC',
      color: 'bg-orange-500',
      rating: 5,
      text: 'The team created an ambiance that perfectly captures our brand identity. Our customers constantly compliment the interior design, and it has significantly enhanced their dining experience.'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Tech Startup CEO',
      avatar: 'ER',
      color: 'bg-purple-500',
      rating: 5,
      text: 'Not only did they design our office space beautifully, but they also built our company website. The seamless integration of physical and digital design is what sets them apart.'
    },
    {
      name: 'Michael Thompson',
      role: 'Boutique Hotel Manager',
      avatar: 'MT',
      color: 'bg-pink-500',
      rating: 5,
      text: 'Our hotel lobby has become an Instagram hotspot thanks to their innovative design. Guest satisfaction scores have increased by 40% since the renovation. Absolutely worth every penny.'
    },
    {
      name: 'Lisa Anderson',
      role: 'Real Estate Developer',
      avatar: 'LA',
      color: 'bg-blue-500',
      rating: 5,
      text: 'I have worked with many design firms, but Urban Spaces stands out for their professionalism and creativity. They delivered three luxury apartments on time and exceeded all expectations.'
    },
    {
      name: 'James Wilson',
      role: 'Coffee Shop Owner',
      avatar: 'JW',
      color: 'bg-green-500',
      rating: 5,
      text: 'They transformed our small coffee shop into a cozy, inviting space that customers love. The design maximizes every square foot while maintaining a warm, welcoming atmosphere.'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-12">
          <span className="inline-block px-4 py-2 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-700 mb-6">
            Client Love
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            What Our Clients<br />Say About Us
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow"
              style={{ height: index % 3 === 0 ? 'auto' : index % 3 === 1 ? 'auto' : 'auto' }}
            >
              <div className="flex items-start space-x-4 mb-6">
                <div className={`w-14 h-14 ${testimonial.color} rounded-full flex items-center justify-center flex-shrink-0`}>
                  <span className="text-white font-bold text-lg">{testimonial.avatar}</span>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">@{testimonial.role}</p>
                </div>
              </div>

              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-teal-500 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 text-sm leading-relaxed">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
